import './AboutUsPageFoundersSection.scss';
import revolutionIconImg from '../../../assets/images/about_us_page/revolution_icon.png'
import ceoImg from '../../../assets/images/about_us_page/ceo.jpg'
import ctoImg from '../../../assets/images/about_us_page/cto.jpg'

const AboutUsPageFoundersSection = () => {
  return (
    <section className="founders-section">
      <div className="founders-container">
        {/* Header */}
        <div className="founders-header">
          <div className="meet-tag">
            <img className="crown-icon" src={revolutionIconImg} alt='revolutionImgIcon'></img>
            Meet The Revolutionaries.
          </div>
          <h2 className="founders-title">
            The Two Minds Behind
            <br />
            <span className="revolution-text">The Revolution</span>
          </h2>
          <p className="founders-description">
            From DTU classrooms to big corporates to disrupting the freelance industry - meet the two visionaries who dared to challenge the status quo.
          </p>
        </div>

        {/* Founders Cards */}
        <div className="founders-cards">
          {/* Top Row - Founder Profiles */}
          <div className="founders-row">
            <div className="founder-card">
              <div className="polaroid-frame">
                <div className="image-placeholder">
                  <img src={ceoImg} alt="Mayank" />
                </div>
                <div className="founder-info">
                  <h3 className="founder-name">Mayank</h3>
                  <p className="founder-title">CEO</p>
                </div>
              </div>
            </div>

            <div className="founder-card">
              <div className="polaroid-frame">
                <div className="image-placeholder">
                  <img src={ctoImg} alt="Akshat" />
                </div>
                <div className="founder-info">
                  <h3 className="founder-name">Akshat</h3>
                  <p className="founder-title">CTO</p>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Row - Founder Quotes */}
          <div className="quotes-row">
            <div className="quote-card">
              <blockquote className="founder-quote">
                "We're not just building a platform, we're building a movement that puts Indian freelancers & business owners where they belong - at the front."
              </blockquote>
              <div className="quote-footer">
                <span className="quote-role">Visionary Leader</span>
              </div>
            </div>

            <div className="quote-card">
              <blockquote className="founder-quote">
                "Our AI doesn't just match skills - it understands dreams, aspirations, and the unique potential every Indian freelancer brings."
              </blockquote>
              <div className="quote-footer">
                <span className="quote-role">Tech Innovator</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUsPageFoundersSection;
